module.exports = __webpack_public_path__ + "static/media/3.62a781c8.jpg";